<template>
    <div>
        <div
            class="modal fade"
            id="detailsModal"
            role="dialog"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Detalhes</h5>
                        <button type="button" class="close" data-dismiss="modal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ul class="nav nav-tabs">
                            <li class="nav-item" @click="activeTab = 1">
                                <a :class="['nav-link clickable', {'active': activeTab == 1}]">Responderam</a>
                            </li>
                            <li class="nav-item" @click="activeTab = 2">
                                <a :class="['nav-link clickable', {'active': activeTab == 2}]">Não responderam</a>
                            </li>
                        </ul>
                        <div class='row' v-show="activeTab == 1">
                            <div class='col-12'>
                                <table class='table table-striped'>
                                <thead>
                                    <th>Nome</th>
                                    <th>Empresa</th>
                                    <th>Filial</th>
                                    <th>Setor</th>
                                    <th>Cargo</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(answered, index) in details.answered" :key="index">
                                        <td>{{ answered.user.name }}</td>
                                        <td>{{ answered.user.company.fantasy_name }}</td>
                                        <td>{{ answered.user.branch.name }}</td>
                                        <td>{{ answered.user.sector.name }}</td>
                                        <td>{{ answered.user.role.name }}</td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                        </div>
                        <div class='row' v-show="activeTab == 2">
                            <div class='col-12'>
                                <table class='table table-striped'>
                                <thead>
                                    <th>Nome</th>
                                    <th>Empresa</th>
                                    <th>Filial</th>
                                    <th>Setor</th>
                                    <th>Cargo</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(missing, index) in details.missing" :key="index">
                                        <td>{{ missing.user.name }}</td>
                                        <td>{{ missing.user.company.fantasy_name }}</td>
                                        <td>{{ missing.user.branch.name }}</td>
                                        <td>{{ missing.user.sector.name }}</td>
                                        <td>{{ missing.user.role.name }}</td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class='row'>
                            <div class='col-6'>
                                <div class="card-title">Aderência</div>
                            <span class="font-italic">Valores exibidos em <strong>quantidade</strong></span>
                            </div>
                            <div class='col-6'>
                                <button v-if="(research.anonymity_level !=2)" class='btn btn-normal float-right' @click="seeDetails()"><i class='fa fa-eye'></i> Detalhes</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4 offset-md-4">
                                <Pie
                                    :chartData="data"
                                    :styles="{height: '400px'}"
                                    :options="options"
                                ></Pie>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pie from "./../Charts/Pie";
export default {
    data() {
        return {
            activeTab: 1,
            details: {
                answered: [],
                missing: []
            },
            data: {
                datasets: [
                    {
                        data: this.research.adderence.data,
                        backgroundColor: ["#36a2eb", "#ff6384"]
                    }
                ],
                labels: this.research.adderence.labels,
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    enabled: true
                },
                 hoverOffset: 4,
                hover: {
                    animationDuration: 30
                },
                
                legend: {
                    display: true
                },

                pointLabelFontFamily: "Quadon Extra Bold",
                scaleFontFamily: "Quadon Extra Bold"
            }
        };
    },
    methods: {
        seeDetails(){
            const self = this
            let api = self.$store.state.api + "researches/answered-and-missing/" + self.research.id;
            self.$http
                .get(api)
                .then(response => {
                    self.details = response.data;
                    $('#detailsModal').modal('show')
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        }
    },
    mounted: function() {},
    props: ["research", "workersCounter"],
    components: {
        Pie
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Reusable/Adderence.vue